export const SUB_NAV_LIST = {
    payments: [
        {name: 'Wallet', route: 'payments-wallet'},
        {name: 'Transactions', route: 'payments-transactions'},
    ],
    suppliers: [
        {name: 'company', route: 'company'},
        {name: 'vendor', route: 'vendor'},
    ],
};
